import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";
import { getPendingAcquisitionProduct, resolvePostAuthDestination } from "../lib/productRouting";

export default function AuthConfirm() {
  const navigate = useNavigate();
  const { getOAuthRoutingState } = useAuth();

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session) {
          const oauthRoutingState = getOAuthRoutingState();
          const destination = await resolvePostAuthDestination({
            requestedRedirect: oauthRoutingState?.redirectTo || "/dashboard",
            allowAcquisition: Boolean(oauthRoutingState?.allowAcquisition || getPendingAcquisitionProduct()),
          });
          navigate(destination, { replace: true });
        } else {
          // No session, redirect to login with confirmed flag
          navigate("/login?confirmed=1", { replace: true });
        }
      } catch (error) {
        console.error("Error confirming email:", error);
        // On error, redirect to login
        navigate("/login?confirmed=1", { replace: true });
      }
    };

    confirmEmail();
  }, [navigate, getOAuthRoutingState]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <div className="text-white text-lg font-medium mb-2">
          Confirming your email...
        </div>
        <div className="text-white/40 text-sm">
          Please wait while we verify your account.
        </div>
      </div>
    </div>
  );
}
